export default "__VITE_ASSET__27ec6b4a__"